import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { NavLink as Link } from "react-router-dom";
import $ from "jquery";
import axios from "../../services/axios";
import { Badge, Card, Modal } from "antd";
import XTable from "../../components/XTable";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";
import SearchBox from "./SearchBox";
import DateFilter from "./DateFilter";
import CandidateCount from "./CandidateCount";
import moment from "moment";

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const RejectedCandidates = () => {
  const consultantName = localStorage.getItem("consultant.name");

  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [isModalVisibleFeedback, setIsModalVisibleFeedback] = useState(false);
  const [candidateInformation, setCandidateInformation] = useState();
  const [defaultDate, setDefaultDate] = useState([]);
  const [current, setCurrent] = useState(1);
  const [load, setLoad] = useState(false);
  const [csvData, setCsvData] = useState([])

  useEffect(() => {
    csvDownload()
  }, [defaultDate])

  const handleCancelFeedback = () => {
    setIsModalVisibleFeedback(false);
  };

  async function mouseClick(candidate) {
    setIsModalVisibleFeedback(true);
    const candidateId = candidate;
    try {
      const { data } = await axios.get("/consultant/candidate/" + candidateId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
        },
      });
      setCandidateInformation(data);
      // setBulkInfo(data);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    setLoad(true)
    axios
      .get(
        `/consultant/Rejected?consultancyName=${consultantName}&search=${searchText}&startDate=${
          defaultDate[0] ? defaultDate[0] : ""
        }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
          },
        }
      )
      .then((res) => {
        setSelectedData(res.data);
        setLoad(false)
      })
      .catch(err => {
        setLoad(false)
      });
  }, [searchText, defaultDate]);

  function csvDownload(){
    axios
    .get(
      `/consultants/csvRejectedCandidates?consultancyName=${consultantName}&startDate=${
        defaultDate[0] ? defaultDate[0] : ""
      }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
        },
      }
    )
    .then((res) => {
      setCsvData(res.data);
      // setLoad(false)
    })
    .catch(err => {
      // setLoad(false)
    });
  }

  // function formatDate(d) {
  //   let date = new Date(d);
  //   var dd = date.getDate();
  //   var mm = date.getMonth() + 1;
  //   var yyyy = date.getFullYear();
  //   var hours = date.getHours();
  //   var minutes = date.getMinutes();
  //   var seconds = date.getSeconds();
  //   if (dd < 10) {
  //     dd = "0" + dd;
  //   }
  //   if (mm < 10) {
  //     mm = "0" + mm;
  //   }
  //   return (d =
  //     dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  // }

  function formatDate(date) {
    const inputDate = date;
    const outputFormat = "DD/MM/YYYY";
    const formattedDate = moment.utc(inputDate).format(outputFormat);
    return formattedDate;
  }

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
    <Dashboard
    setSearchText={setSearchText}
    setDefaultDate={setDefaultDate}
    setCurrent={setCurrent}
    csvData={csvData}
    >
      {isConsultant() && (
        <div className="col-lg-12">
          <div className="row">
            <div className="col-md-5 col-sm-12">
              <h1>Rejected Candidates:- {selectedData?.length}</h1>
            </div>
            {/* <div className="col-md-4 col-sm-12">
              <DateFilter setDefaultDate={setDefaultDate} />
            </div>
            <div className="col-md-3 col-sm-12">
              <SearchBox setSearchText={setSearchText} />
            </div> */}
          </div>
          <div className="row">{/* <CandidateCount /> */}</div>
          <Card className="border">
            <XTable
              columns={["Name", "Email", "Phone", "Date Applied", "Interview Status", "View"]}
              rows={selectedData?.map((ele) => {
                return {
                  Name: ele?.name,
                  //   Process: ele?.processId[0]?.name,
                  Email: ele?.email,
                  Phone: ele?.mobileNo,
                  "Date Applied": formatDate(ele?.createdAt),
                  "Interview Status": ele.L4_Status !== "" ? `L4_Status: ${ele.L4_Status}` :
                  ele.L3_Status !== "" ? `L3_Status: ${ele.L3_Status}` :
                  ele.L2_Status !== "" ? `L2_Status: ${ele.L2_Status}` :
                  ele.L1_Status !== "" ? `L1_Status: ${ele.L1_Status}` : "",

                  View: (
                    <div style={{ display: "flex" }}>
                      <td
                        onClick={() => mouseClick(ele._id)}
                        className="ml-1 d-inline"
                      >
                        <i class="fa fa-eye cursor-pointer"></i>
                      </td>
                    </div>
                  ),
                };
              })}
            />

            <Modal
              className="request-modal"
              title={<h5 className="font-weight-bold mb-0">STATUS</h5>}
              visible={isModalVisibleFeedback}
              footer={false}
              onCancel={handleCancelFeedback}
            >
              <div className="mb-4 mt-0 card p-2">
                <h4 className="hr-ratings-title m-0">
                  {"Personal Information"}
                </h4>
                <table className="table table-candidate mt-1">
                  <tbody>
                    <tr>
                      <td>Name:</td>
                      <td>{candidateInformation?.name}</td>
                    </tr>
                    <tr>
                      <td>Email:</td>
                      <td>{candidateInformation?.email}</td>
                    </tr>
                    <tr>
                      <td>Phone:</td>
                      <td>{candidateInformation?.mobileNo}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mb-4 mt-0 card p-2">
                <h4 className="hr-ratings-title m-0">{"Interview Status"}</h4>
                <table className="table table-candidate mt-1">
                  <tbody>
                    <tr>
                      <td>L1 Round Status:</td>
                      <td>{candidateInformation?.L1_Status}</td>
                    </tr>
                    <tr>
                      <td>L2 Round Status:</td>
                      <td>{candidateInformation?.L2_Status}</td>
                    </tr>
                    <tr>
                      <td>L3 Round Status:</td>
                      <td>{candidateInformation?.L3_Status}</td>
                    </tr>
                    <tr>
                      <td>Client Round Status:</td>
                      <td>{candidateInformation?.L4_Status}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Modal>
          </Card>
        </div>
      )}
    </Dashboard>
    </div>
  );
};

export default RejectedCandidates;
